import Cookies from "js-cookie";
import { API_BASE_URL } from "../../config";
import { createApiClient } from "./createApiClient";

const getToken = () => {
  const token = Cookies.get("token");
  const tempToken = Cookies.get("tempToken");
  if (token || tempToken) return decodeURIComponent(token || tempToken);
  return "";
};

const getRefreshToken = () => {
  const refreshToken = Cookies.get("refreshToken");
  return refreshToken || "";
};

/**
 * Legacy authenticated API client (existing Kubera backend routes).
 * Future private CRM routes can use a separate client with API_PATHS.PRIVATE.
 */
const privateClient = createApiClient({
  baseURL: API_BASE_URL,
});

privateClient.interceptors.request.use((config) => {
  const token = getToken();
  const refreshToken = getRefreshToken();
  if (token) config.headers["X-Access-Token"] = token;
  if (refreshToken) config.headers["Refresh-Token"] = refreshToken;
  return config;
});

export default privateClient;
